import subDays from 'date-fns/subDays';
import startOfWeek from 'date-fns/startOfWeek';
import endOfWeek from 'date-fns/endOfWeek';
import startOfMonth from 'date-fns/startOfMonth';
import endOfMonth from 'date-fns/endOfMonth';
import startOfYear from 'date-fns/startOfYear';
import endOfYear from 'date-fns/endOfYear';
import type { TDateRangePreset } from '@types';

export const DEFAULT_PRESETS: TDateRangePreset[] = [
	{
		key: 'today',
		label: 'Today',
		resolve: (t) => ({ start: t, end: t }),
	},
	{
		key: 'last_7_days',
		label: 'Last 7 days',
		resolve: (t) => ({ start: subDays(t, 6), end: t }),
	},
	{
		key: 'this_week',
		label: 'This week',
		resolve: (t) => ({
			start: startOfWeek(t, { weekStartsOn: 0 }),
			end: endOfWeek(t, { weekStartsOn: 0 }),
		}),
	},
	{
		key: 'this_month',
		label: 'This month',
		resolve: (t) => ({ start: startOfMonth(t), end: endOfMonth(t) }),
	},
	{
		key: 'this_year',
		label: 'This year',
		resolve: (t) => ({ start: startOfYear(t), end: endOfYear(t) }),
	},
];
